import React from "react";
import './styles.scss';
import { Translate } from "react-localize-redux";

const PrivacyRow = ({ rowOffset }) => (
  <li className="form-row">
    <div className={`col-${rowOffset}`}></div>
    <div className="col-1">
      <h4 className="privacy-label"><Translate id="PrivacyText" /></h4>
    </div>
  </li>
);

export default PrivacyRow;


// WEBPACK FOOTER //
// ./src/components/forms/PrivacyRow/PrivacyRow.jsx